import React, { useState } from "react";
import { executeLambda } from "../../../node/BackendData/LambdaExecutor";
import { useProperty,getLogger } from "@olympeio/core";
import {
  Button,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
  IconButton,
  DialogContent, Dialog, DialogTitle
} from "@mui/material";
import { _theme } from "../../shared/_theme";
import { ThemeProvider } from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";

const FeedBackPop = (props) => {
  const [feedbackValue, setFeedBackValue] = useState(null);
  const [optionValue, setOptionValue] = useState(null);
  const feedbackAction = useProperty(props.ctx, "PCT feedback");
  const vendorSiteID = props.vendorID;
  const storedQueryName = "pctFeedbackUpsert";
  const [open, setOpen] = useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setOptionValue(null);
  };



  // Helper function to generate the latest queryBody
  // Plant, materian and mainVendor fields are left empty for now and it will ready to handle future requirements without requiring major changes to the underlying structure.
  const generateQueryBody = (selectedOption) => {
    return {
      storedQuery: {
        name: storedQueryName,
        bindings: {
          event_id: props.eventID,
          vendorSiteId: vendorSiteID,
          feedback: selectedOption,
          plant: "",
          material: "",
          mainVendor: "",
        },
      },
    };
  };

  const handleChange = async (event) => {
    let selectedOption = event.target.value;
    getLogger('feedBackLoop').log("Selected value:", selectedOption);
    // Update optionValue state
    setOptionValue(selectedOption);
    // Generate query body with the latest selected option
    const queryBody = generateQueryBody(selectedOption);

    if (selectedOption === 'No') {
      handleClickOpen(); // Open dialog if feedback is "No"
    } else {
      updateFeedBackVal(selectedOption, queryBody); // Pass selected value directly
    }
    getLogger('feedBackLoop').log("Event triggered with queryBody:", queryBody);
  };
  const updateFeedBackVal = async (feedbackVal, queryBody) => {
    getLogger('feedBackLoop').log("Updated feedback triggered with value:", feedbackVal);
    try {
      const eventData = await executeLambda(props.ctx, feedbackAction, [queryBody]);
      const parsedEventData = JSON.parse(eventData);
      feedbackVal === 'No' ? setOpen(false) : null;
      if(Array.isArray(parsedEventData)&& parsedEventData.length ===0){
        setFeedBackValue(true);
      }
      else{
        setFeedBackValue(null);
      }
      
    } catch (error) {
      getLogger('feedBackLoop').error("Error updating feedback:", error);
    }
  };
  return (
    feedbackValue !== true ? (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          margin: "10px",
        }}
      >
        <FormControl>
          <FormLabel id="demo-controlled-radio-buttons-group">
            Was this alert helpful?
          </FormLabel>
          <RadioGroup
            aria-labelledby="demo-controlled-radio-buttons-group"
            name="controlled-radio-buttons-group"
            value={optionValue}
            onChange={handleChange}
            row
          >
            <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
            <FormControlLabel value="No" control={<Radio />} label="No" />
          </RadioGroup>
        </FormControl>
        {/* Popup for rejected feedback */}
        <ThemeProvider theme={_theme}>
          <Dialog onClose={handleClose} open={open}>
            <DialogTitle className="datagrid-dialog-closeIconContainer">
              <IconButton onClick={handleClose}>
                <CloseIcon fontSize="large" />
              </IconButton>
            </DialogTitle>
            <DialogContent className="base-popup-content base-feedBack-popup-content">
              <h4 style={{ fontWeight: '400' }}>We will remove this alert on the next day</h4>
              <h6 style={{ fontWeight: '400', marginBottom: '40px' }}>Do you confirm?</h6>
              <div>
                <Button
                  className='add-material-popup-button'
                  variant='contained'
                  onClick={() => {
                    // Update the query body before calling updateFeedBackVal
                    const queryBody = generateQueryBody(optionValue);
                    updateFeedBackVal(optionValue, queryBody);
                  }} // Pass optionValue and queryBody here
                  sx={{
                    margin: '0 10px',
                    pointerEvents: 'auto !important',
                    width: '140px'
                  }}>
                  Yes, remove
                </Button>
                <Button
                  className='add-material-popup-button'
                  variant='outlined'
                  onClick={handleClose}
                  sx={{
                    margin: '0 10px',
                    pointerEvents: 'auto !important',
                    width: '140px'
                  }}>
                  No
                </Button>
              </div>
            </DialogContent>
          </Dialog>
        </ThemeProvider>
      </div>
    ) : null
  );
};

export default FeedBackPop;
